import { Heart, MessageCircle, Repeat2, Bookmark, MoreHorizontal, ThumbsUp, Send, Share2 } from "lucide-react";

function TokenizedText({ text, hashtags = [], cta = "" }) {
  const tail = hashtags.length ? " " + hashtags.map((h) => `#${h.replace(/^#/, "")}`).join(" ") : "";
  const ctaLine = cta ? `\n\n${cta}` : "";
  return (
    <p className="whitespace-pre-wrap text-sm leading-relaxed text-[#0B2B33]">
      {text || <span className="italic text-[#8A97A0]">Your caption preview will appear here…</span>}
      {tail ? <span className="text-[#1F5FD8]">{tail}</span> : null}
      {ctaLine}
    </p>
  );
}

export function NetworkPreview({ network, variant, brand }) {
  const caption = variant?.caption || "";
  const hashtags = variant?.hashtags || [];
  const cta = variant?.cta || "";
  const brandName = brand?.name || "Your brand";
  const handle = (brand?.handle || brand?.slug || "yourbrand").replace(/^@/, "");

  if (network === "instagram") {
    return (
      <div data-testid="preview-instagram" className="overflow-hidden rounded-xl border border-[#E4E9EF] bg-white">
        <div className="flex items-center justify-between px-3 py-2">
          <div className="flex items-center gap-2">
            <div className="h-8 w-8 rounded-full bg-gradient-to-tr from-[#f58529] via-[#dd2a7b] to-[#8134af]" />
            <div className="text-sm font-semibold text-[#0B2B33]">{handle}</div>
          </div>
          <MoreHorizontal className="h-4 w-4 text-[#8A97A0]" />
        </div>
        <div className="aspect-square w-full bg-[#F6F8FA]" />
        <div className="flex items-center gap-3 px-3 py-2">
          <Heart className="h-5 w-5 text-[#0B2B33]" />
          <MessageCircle className="h-5 w-5 text-[#0B2B33]" />
          <Send className="h-5 w-5 text-[#0B2B33]" />
          <Bookmark className="ml-auto h-5 w-5 text-[#0B2B33]" />
        </div>
        <div className="px-3 pb-3">
          <TokenizedText text={caption} hashtags={hashtags} cta={cta} />
        </div>
      </div>
    );
  }

  if (network === "linkedin") {
    return (
      <div data-testid="preview-linkedin" className="rounded-xl border border-[#E4E9EF] bg-white p-4">
        <div className="flex items-center gap-3">
          <div className="h-10 w-10 rounded-full bg-[#0A66C2]/10" />
          <div>
            <div className="text-sm font-semibold text-[#0B2B33]">{brandName}</div>
            <div className="text-xs text-[#8A97A0]">Company · 12.4k followers · Just now</div>
          </div>
        </div>
        <div className="mt-3"><TokenizedText text={caption} hashtags={hashtags} cta={cta} /></div>
        <div className="mt-3 aspect-[16/9] w-full rounded-lg bg-[#F6F8FA]" />
        <div className="mt-3 flex items-center gap-4 border-t border-[#E4E9EF] pt-3 text-sm text-[#43535E]">
          <span className="inline-flex items-center gap-1"><ThumbsUp className="h-4 w-4" /> Like</span>
          <span className="inline-flex items-center gap-1"><MessageCircle className="h-4 w-4" /> Comment</span>
          <span className="inline-flex items-center gap-1"><Repeat2 className="h-4 w-4" /> Repost</span>
          <span className="inline-flex items-center gap-1"><Share2 className="h-4 w-4" /> Send</span>
        </div>
      </div>
    );
  }

  if (network === "facebook") {
    return (
      <div data-testid="preview-facebook" className="rounded-xl border border-[#E4E9EF] bg-white p-4">
        <div className="flex items-center gap-3">
          <div className="h-10 w-10 rounded-full bg-[#1877F2]/10" />
          <div>
            <div className="text-sm font-semibold text-[#0B2B33]">{brandName}</div>
            <div className="text-xs text-[#8A97A0]">Just now · Public</div>
          </div>
        </div>
        <div className="mt-3"><TokenizedText text={caption} hashtags={hashtags} cta={cta} /></div>
        <div className="mt-3 aspect-[4/3] w-full rounded-lg bg-[#F6F8FA]" />
      </div>
    );
  }

  // x
  const total = caption.length + (hashtags.length ? 1 + hashtags.map((h) => h.length + 2).reduce((a, b) => a + b, 0) : 0);
  const over = total - 280;
  return (
    <div data-testid="preview-x" className="rounded-xl border border-[#E4E9EF] bg-white p-4">
      <div className="flex items-center gap-3">
        <div className="h-10 w-10 rounded-full bg-black/10" />
        <div>
          <div className="text-sm font-semibold text-[#0B2B33]">{brandName}</div>
          <div className="text-xs text-[#8A97A0]">@{handle} · now</div>
        </div>
      </div>
      <div className="mt-3"><TokenizedText text={caption} hashtags={hashtags} cta={cta} /></div>
      <div className={`mt-3 text-xs ${over > 0 ? "text-[#E3252A]" : "text-[#8A97A0]"}`}>
        {over > 0 ? `Over the 280 limit by ${over}` : `${280 - total} chars left`}
      </div>
    </div>
  );
}
